module.exports = __webpack_public_path__ + "img/papillary-reaction-2.898b17d1.jpg";